package org.teddapp.project.db

/**
 * Mise en mots de la révision espacée. La règle elle-même — la case après une
 * réussite ou un oubli, et le nombre de jours qui en découle — appartient au noyau.
 *
 * Ce qui reste ici ne décide de rien : ça met en français un nombre de jours qu'on
 * a reçu. Garder une seconde version de la règle la ferait diverger à la première
 * modification, et plus aucune des deux ne serait fiable.
 */
object Leitner {
    /** Libellé lisible d'un délai : « revient dans 7 jours ». */
    fun label(days: Int): String = when {
        days <= 1 -> "revient demain"
        else -> "revient dans $days jours"
    }
}
